import { IColors, ISpacing } from "@swiggy-private/dls-web-common/dist/components/types";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const Container = styled(Text)<{ $inline?: boolean; $gap?: keyof ISpacing }>(
    ({ theme, $inline, $gap }) => ({
        display: $inline ? "inline-flex" : "flex",
        gap: $gap ? theme.spacing?.[$gap] : 0,
    })
);

export const StyledAnchor = styled("a")<{
    $anchorColor?: keyof IColors;
    $anchorTextDecorationColor?: keyof IColors;
}>(({ theme, $anchorColor, $anchorTextDecorationColor }) => ({
    color: $anchorColor ? theme.colors.light[$anchorColor] : theme.colors.light.text_Med_Emphasis,
    textDecorationColor: $anchorTextDecorationColor
        ? theme.colors.light[$anchorTextDecorationColor]
        : theme.colors.light.text_Med_Emphasis,
}));

export const Separator = styled.span(({ theme }) => ({
    color: theme.colors.light.text_inverse_disabled,
}));
